export interface SecurityFormValues {
  inactivityTimeoutEnabled: boolean;
  inactivityTimeoutThresholdMinutes: string;
}

export const RECOMMENDED_INACTIVITY_TIMEOUT_THRESHOLD = "15";
